import React from 'react';

import UnderConstructionPage from './UnderConstructionPage';

const ContactPage: React.FC = () => <UnderConstructionPage />;

export default ContactPage;
